export default __webpack_public_path__ + "static/media/billing.dbacdc1d.svg";